import { I18n } from '@calendly/i18n';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { HolidaySettings } from './holiday_settings';
import { FlexContainer } from './styles';
const HolidayContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={props.className} />;
});
const holidayContentCss = "h1mb5xkz";
const HolidayContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(holidayContentCss, props.className)} />;
});
export const HolidaysSection = () => <HolidayContainer>
    <HolidayContent>
      <FlexContainer>
        <TitleText level={3} size="small">{I18n.t('publisher.availability_page.advanced_settings.holidays.title')}</TitleText>
        <BodyText color="muted" size="medium">
          {I18n.t('publisher.availability_page.advanced_settings.holidays.subheader')}
        </BodyText>
      </FlexContainer>
      <HolidaySettings />
    </HolidayContent>
  </HolidayContainer>;

require("./holidays_section.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./holidays_section.js");